import { render, staticRenderFns } from "./snapshot-list.vue?vue&type=template&id=338bd8ea&scoped=true"
import script from "./snapshot-list.vue?vue&type=script&lang=js"
export * from "./snapshot-list.vue?vue&type=script&lang=js"
import style0 from "./snapshot-list.vue?vue&type=style&index=0&id=338bd8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338bd8ea",
  null
  
)

export default component.exports